import { ApplicationRef, enableProdMode, ErrorHandler, Injector } from '@angular/core';
import { disableDebugTools, enableDebugTools } from '@angular/platform-browser';
import { AppGlobal } from '@core/utils/app';
import { environment } from '@environments/environment';

/**
 * Environment Providers
 */
let PROVIDERS: any[] = [
    /**
     * Common env directives
     */
];

/**
 * Angular debug tools in the dev console
 * https://github.com/angular/angular/blob/86405345b781a9dc2438c0fbe3e9409245647019/TOOLS_JS.md
 */
let _decorateModuleRef = <T>(value: T): T => {
    return value;
};

let w: any = window;

const env: string = environment.value;

if (env === 'production' || env === 'demo' || env === 'release') {
    enableProdMode();

    /**
     * Production
     */
    _decorateModuleRef = (modRef: any) => {
        // disableDebugTools();
        AppGlobal.setInjector(modRef.injector);
        AppGlobal.setRef(modRef.injector.get(ApplicationRef));

        return modRef;
    };

    PROVIDERS = [
        ...PROVIDERS
    ];

} else {

    _decorateModuleRef = (modRef: any) => {
        const appRef = modRef.injector.get(ApplicationRef);
        const cmpRef = appRef.components[0];

        let _ng = (<any> window).ng;
        enableDebugTools(cmpRef);
        (<any> window).ng.probe = _ng.probe;
        (<any> window).ng.coreTokens = _ng.coreTokens;

        AppGlobal.setInjector(modRef.injector);
        AppGlobal.setRef(appRef);

        return modRef;
    };

    /**
     * Development
     */
    PROVIDERS = [
        ...PROVIDERS
    ];

}

export const decorateModuleRef = _decorateModuleRef;

export const ENV_PROVIDERS = [
    ...PROVIDERS
];
